export default 'fonts/6f8fbf1f1f67d834ebfefbffaa9b495b.eot';